<template>
  <div>
    <v-text-field
      v-model="src"
      :label="$gettext('Image Url')"
    />
    <v-text-field
      v-model="alt"
      :label="$gettext('Alternative Text')"
    />
    <v-btn @click="addImage">
      <translate>Add Image</translate>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "TiptapImageUrl",
  data() {
    return {
      src: null,
      alt: null,
    };
  },
  methods: {
    addImage() {
      this.$emit('select-file', {
      src: this.src,
      alt: this.alt
    })
    this.src = null
    this.alt = null
    },
  },
};
</script>
